
import { loadCustomScript } from '@paypal/paypal-js'

const querystring = require('query-string')

const googleCaptchaUrl = 'https://www.google.com/recaptcha/api.js?render='
const loqateUrl = 'https://services.postcodeanywhere.co.uk/js/address-3.91.min.js'
const loqateCss = 'https://services.postcodeanywhere.co.uk/css/address-3.91.min.css'

const toFixedFix = (n, prec) => {
    const k = 10 ** prec
    return `${Math.round(n * k) / k}`
}

const helpers = {
    formatCurrencyIso(value, specificCurrency = null) {
        let currency = window.Alpine.store('currency')

        if (specificCurrency) {
            const currencies = JSON.parse(decodeURIComponent(window.Alpine.store('currencies')))
            currency = currencies.find((obj) => obj.id_currency == specificCurrency)
        }

        return this.formatCurrency(value, currency.iso_code, specificCurrency)
    },
    formatCurrencySign(value, specificCurrency = null, recalculateRate = false, decimals = null) {
        let currency = window.Alpine.store('currency')

        if (specificCurrency) {
            const currencies = JSON.parse(decodeURIComponent(window.Alpine.store('currencies')))
            currency = currencies.find((obj) => obj.id_currency == specificCurrency)
        }

        let price = value
        if (recalculateRate !== false) {
            price *= recalculateRate
        }

        return this.formatCurrency(price, currency.sign, specificCurrency, decimals)
    },
    numberFormat(number, decimals, decPoint, thousandsSep) {
        // Strip all characters but numerical ones.
        const formattedNumber = (`${number}`).replace(/[^0-9+\-Ee.]/g, '')
        const n = !Number.isFinite(+formattedNumber) ? 0 : +formattedNumber
        const prec = !Number.isFinite(+decimals) ? 0 : Math.abs(decimals)
        const sep = (typeof thousandsSep == 'undefined') ? ',' : thousandsSep
        const dec = (typeof decPoint == 'undefined') ? '.' : decPoint
        let s = ''

        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.')
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || ''
            s[1] += new Array(prec - s[1].length + 1).join('0')
        }
        return s.join(dec)
    },
    formatCurrency(value, char, specificCurrency = null, currencyDecimals = null) {
        let currency = window.Alpine.store('currency')

        if (specificCurrency !== null) {
            const currencies = JSON.parse(decodeURIComponent(window.Alpine.store('currencies')))
            currency = currencies.find((obj) => obj.id_currency == specificCurrency)
        }

        const decimals = currencyDecimals != null ? currencyDecimals : (currency.decimals == '1' ? 2 : 0)
        const blank = currency.blank == '1' ? ' ' : ''

        switch (parseInt(currency.format)) {
        /* X 0,000.00 */
        case 1:
            return char + blank + this.numberFormat(value, decimals, '.', ',')
            /* 0 000,00 X */
        case 2:
            return this.numberFormat(value, decimals, ',', ' ') + blank + char
            /* X 0.000,00 */
        case 3:
        default:
            return char + blank + this.numberFormat(value, decimals, ',', '.')
            /* 0,000.00 X */
        case 4:
            return this.numberFormat(value, decimals, '.', ',') + blank + char
            /* X 0'000.00  Added for the switzerland currency */
        case 5:
            return this.numberFormat(value, decimals, '.', "'") + blank + char
        }
    },
    processServersideErrors(data) {
        if (data.errors) {
            Object.keys(data.errors).forEach((key) => {
                if (this.fieldKeys.includes(key)) {
                    this.errors[key] = data.errors[key].join(', ')
                } else {
                    if (Object.prototype.hasOwnProperty.call(this, 'nonFieldErrors')) {
                        this.errors.nonFieldErrors = ''
                    }

                    if (this.errors.nonFieldErrors === undefined) {
                        this.errors.nonFieldErrors = ''
                    }

                    this.errors.nonFieldErrors += ` ${data.errors[key].join(', ')}`
                }
            })
        } else if (data.message) {
            // got no errors, check the message and use that only
            this.errors.nonFieldErrors = data.message
        }
    },
    getQueryVar(key) {
        const query = querystring.parse(window.location.search)
        return query[key]
    },
    buildQueryString(o) {
        return querystring.stringify(o)
    },
    successfulSubmission: false,
    submitting: false,
    showBasicErrors: false,
    errors: {},
    hasError(key) {
        return key in this.errors && this.errors.nonFieldErrors !== ''
    },
    addressFinderSetup(element_id = 'autocomplete') {
        return new Promise((resolve, reject) => {
            const css = document.createElement('link')
            css.setAttribute('rel', 'stylesheet')
            css.setAttribute('type', 'text/css')
            css.setAttribute('href', loqateCss)
            document.getElementsByTagName('head')[0].appendChild(css)

            loadCustomScript({ url: loqateUrl }).then(() => {
                // setup address finder
                const fields = [
                    { element: element_id, field: '' },
                ]

                const countries = window?.accuvars?.address_suggestion_country_codes?.join(',') ?? ''

                const options = {
                    key: process.env.MIX_LOQATE_KEY,
                    setCountryByIP: process.env.MIX_LOQATE_IP_LOCATE,
                    GeoLocationEnabled: process.env.MIX_LOQATE_GEOLOCATE,
                    GeoLocationRadius: 50,
                    GeoLocationMaxItems: 10,
                    // some strangeness -> https://www.loqate.com/resources/support/setup-guides/advanced-setup-guide/
                    // but seems to work with this
                    search: { countries },
                }

                this.addressAutocompleteField = new window.pca.Address(fields, options)

                // for soe reason select event is not caught
                // fields dont populate if they are not visible so we need make visible on prepopulate
                this.addressAutocompleteField.listen('prepopulate', () => {
                    this.enteringManually = true
                })

                this.addressAutocompleteField.listen('populate', (address) => {
                    this.address1 = address.Line1
                    this.address2 = address.Line2
                    if (this.company === '') {
                        this.company = address.Company
                    }
                    this.city = address.City
                    this.postcode = address.PostalCode
                    this.setCountryAndState(address.CountryIso3, address.ProvinceCode)
                })

                // Prevents the autocomplete being empty when the input with a value is focused
                let shown = false
                this.addressAutocompleteField.listen('show', () => {
                    setTimeout(() => {
                        const element = document.getElementById(element_id)
                        if (!shown && element.value) {
                            element.dispatchEvent(new KeyboardEvent('keyup'))
                        }
                        shown = true
                    }, 0)
                })

                this.addressAutocompleteField.listen('hide', () => {
                    shown = false
                })

                resolve(true)
            }).catch((error) => reject(error))
        })
    },
    initAndExecuteGoogleCaptcha(action) {
        return new Promise((resolve, reject) => {
            loadCustomScript({ url: googleCaptchaUrl + process.env.MIX_RECAPTCHA_V3_SITE_KEY }).then(() => {
                grecaptcha.ready(() => resolve(grecaptcha.execute(process.env.MIX_RECAPTCHA_V3_SITE_KEY, {
                    action,
                })))
            }).catch((error) => reject(error))
        })
    },
    processErrors(errorData) {
        this.processServersideErrors(errorData)
        if (this.hasError('nonFieldErrors') !== false) {
            window.dispatchEvent(new CustomEvent('create-toast', {
                detail: {
                    title: 'We encountered a problem...',
                    message: this.errors.nonFieldErrors,
                    type: 'error',
                },
            }))
        }
    },
    /**
     * @param {() => void} func
     * @param {string[]} dependencies
     */
    watchMany(func, dependencies = [], callImmediately = true) {
        dependencies.forEach((dep) => this.$watch(dep, func))
        if (callImmediately) {
            func()
        }
    },
}

export default helpers
